module.exports = __webpack_public_path__ + "img/disaster_relief-stage_2.7.543edd87.jpg";